import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import NamingTip from "./naming-tip.mdx";
import SettingProperties from "./setting-properties-text.mdx";
import Intro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`PostHog.with(this)
       .capture("User signed up");
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`PostHog.with(this)
       .capture("User signed up", new Properties()
              .putValue("login_type", "email")
              .putValue("is_free_trial", true));
`}</code></pre>
    <h3 {...{
      "id": "capturing-screen-views"
    }}>{`Capturing screen views`}</h3>
    <p>{`With `}<a parentName="p" {...{
        "href": "/docs/libraries/android#all-configuration-options"
      }}><inlineCode parentName="a">{`recordScreenViews()`}</inlineCode></a>{`, PostHog will try to record all screen changes automatically.`}</p>
    <p>{`If you want to manually send a new screen capture event, use the `}<inlineCode parentName="p">{`screen`}</inlineCode>{` function.`}</p>
    <p>{`This function requires a `}<inlineCode parentName="p">{`name`}</inlineCode>{`. You may also pass in an optional `}<inlineCode parentName="p">{`properties`}</inlineCode>{` object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`PostHog.with(this)
       .screen("Dashboard", new Properties()
                                  .putValue("background", "blue")
                                  .putValue("hero", "superhog"));
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      